import './backButton.scss';

import { FormattedMessage } from 'react-intl';
import { Button, ButtonColor, ButtonVariant, Size } from '@eliberty/design-system-react';

interface BackToResultsButtonProps {
  /** Variant of the button */
  variant: ButtonVariant;
  /** Size of the button */
  size: Size;
  /** The color of the button */
  color: ButtonColor;
  /** The callback function called when the button is clicked */
  onClick: () => void;
}

/** Component used to display the 'back to results' button of the product details page */
const BackButton = ({ variant, size, color, onClick }: BackToResultsButtonProps) => {
  return (
    <div className='BackButton'>
      <Button
        variant={variant}
        color={color}
        size={size}
        onClick={onClick}
        leadingIcon='chevron-left'
      >
        <FormattedMessage id='back' defaultMessage='Back' />
      </Button>
    </div>
  );
};

export default BackButton;
